import { GetStaticProps, GetStaticPropsResult, NextPage } from 'next';
import Head from 'next/head';
import Link from 'next/link';
import { BlogPost } from '../../backend/db/all-entities';
import Database from '../../backend/db/database';
import Layout from '../../react-components/layout';
import cardGrid from '../../styles/card-grid.module.css';
import { getBlogPosts } from '../api/blog-posts';

interface Props {
  posts: Pick<BlogPost, 'id' | 'title' | 'dateCreated'>[];
}

const Blog: NextPage<Props> = ({ posts }) => (
  <Layout>
    <Head>
      <title>Blog</title>
    </Head>
    <h1 className='select-none'>Recent Blog Posts</h1>
    <div className={cardGrid.cardGrid}>
      {posts.length > 0
        ? posts.map(post => (
            <Link href='/blog/[id]' as={`/blog/${post.id}`} key={post.id}>
              <a className='bg-gray-700 rounded p-2'>
                <div className='flex justify-between text-gray-400 select-none'>
                  <span>{new Date(post.dateCreated).toLocaleDateString()}</span>
                  <span>by FITSOCIETY.COM</span>
                </div>
                <div className='text-white text-xl font-bold'>{post.title}</div>
              </a>
            </Link>
          ))
        : 'Nothing has been posted yet.'}
    </div>
  </Layout>
);

export const getStaticProps: GetStaticProps<Props> = async () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return Database.useManager(async (manager): Promise<GetStaticPropsResult<Props>> => {
    const posts = await getBlogPosts(manager);
    return { props: { posts: JSON.parse(JSON.stringify(posts)) }, revalidate: 60 };
  });
};

export default Blog;
